import React from   'react';
import { FaCubes, FaGraduationCap, FaHouseDamage, FaHouseUser, FaLifeRing, FaMapPin, FaMoneyCheck, FaPeopleCarry, FaRoute, FaShare, FaShoppingBasket, FaSquare, FaUser, FaUsers } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import { LinkNavegacion } from '../../Utils/LinkNavegacion';
const MenuVerDiagnosticos = () => {

return (
    <div className="card">
        <div className="card-header">
            <div className="row">
                <div>
                    <LinkNavegacion enlace={'/diagnosticos/datospersonalescabeza'} titulo="Cabeza" icon={FaUser} tooltip={'Datos personales (cabeza)'} />
                    <LinkNavegacion enlace={'/diagnosticos/datospersonaleshogar'} titulo="Hogar" icon={FaUsers} tooltip={'Datos personales (hogar)'} />
                    <LinkNavegacion enlace={'/diagnosticos/ubicacion'} titulo="Ubicacion" icon={FaMapPin} tooltip={'Ubicacion'} />
                    <LinkNavegacion enlace={'/diagnosticos/desplazamiento'} titulo="Hechos" icon={FaSquare} tooltip={'Hechos'} />
                    <LinkNavegacion enlace={'/diagnosticos/perdidasbienes'} titulo="Perdidas bienes" icon={FaHouseDamage} tooltip={'Perdidas bienes'} />
                    <LinkNavegacion enlace={'/diagnosticos/perdidasotras'} titulo="Perdidas otras" icon={FaHouseDamage} tooltip={'Perdidas (Otras)'} />
                    <LinkNavegacion enlace={'/diagnosticos/deudas'} titulo="Deudas" icon={FaMoneyCheck} tooltip={'Deudas'} />
                    <LinkNavegacion enlace={'/diagnosticos/unidadfamiliar'} titulo="Unidad familiar" icon={FaPeopleCarry} tooltip={'Unidad familiar'} />
                    <LinkNavegacion enlace={'/diagnosticos/vidalibertad'} titulo="Vida libertad" icon={FaLifeRing} tooltip={'Vida y libertad'} />
                    <LinkNavegacion enlace={'/diagnosticos/retorno'} titulo="Retorno" icon={FaRoute} tooltip={'Retorno'} />
                    <LinkNavegacion enlace={'/diagnosticos/retornoxintegrantes'} titulo="Retorno integrantes" icon={FaRoute} tooltip={'Retorno integrantes'} />
                    <LinkNavegacion enlace={'/diagnosticos/seguridadalimentaria'} titulo="Seguridad alimentaria" icon={FaShoppingBasket} tooltip={'Seguridad alimentaria'} />
                </div>
            </div>
            <div className="row">
                <div>
                    <LinkNavegacion enlace='/diagnosticos/autonomia' titulo="Autonomia" icon={FaCubes} tooltip={'Autonomia'} />
                    <LinkNavegacion enlace='/diagnosticos/autonomiaformacion' titulo="Formacion" icon={FaGraduationCap} tooltip={'Autonomia (Formacion)'} />
                    <LinkNavegacion enlace='/diagnosticos/albergue' titulo="Albergue" icon={FaHouseUser} tooltip={'Albergue'} />
                    <LinkNavegacion enlace='/diagnosticos/seguimientoretorno' titulo="Seg. retorno" icon={FaShare} tooltip={'Seguimiento retorno'} />
                </div>
            </div>
        </div>
    {/* /.card-body */}
    </div>
);
};

export default MenuVerDiagnosticos;